// StreetStepper.tsx - the Preflop / Flop / Turn / River progress stepper (locked DX4). Streets before
// the current one read "done" (mint), the current one reads "on" (mint gradient); tapping a pip jumps
// to that street. Controlled: the parent owns the current street index.
export const STREET_LABELS = ['Preflop', 'Flop', 'Turn', 'River'] as const;

export interface StreetStepperProps {
  /** current street index 0..3. */
  street: number;
  onSelect: (street: number) => void;
}

export function StreetStepper({ street, onSelect }: StreetStepperProps) {
  return (
    <div className="streetbar">
      {STREET_LABELS.map((label, i) => {
        const cls = 'sp' + (i < street ? ' done' : '') + (i === street ? ' on' : '');
        return (
          <button key={label} type="button" className={cls} onClick={() => onSelect(i)}>
            <div className="rail" />
            <div className="lb">{label}</div>
          </button>
        );
      })}
    </div>
  );
}
